import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ChevronRight, GraduationCap } from "lucide-react";
import { ROUTES } from "../../../routes";
import { useAppSelector } from "../../../app/hooks";
import { selectOrganization } from "../../organization/organization-slice";
import { OrganizationKind } from "../../organization/enums/OrganizationKind";

/**
 * Settings-page card linking to the programmes; every instructor may open it (read-only below Admin).
 * Only a driving school reads "training plans"; any other school gets its own word for Programmes.
 */
const ProgrammesSettingsLink: React.FC = () => {
  const { t } = useTranslation();
  const isDrivingSchool = useAppSelector(selectOrganization)?.kind === OrganizationKind.Fahrschule;

  return (
    <div className="with-border rounded-2xl p-4 lg:p-6 transition-colors hover:border-primary-50/40 dark:hover:border-primary-70/40">
      <div className="mb-4 flex items-start gap-3">
        <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-primary-95 text-primary-50 dark:bg-primary-30 dark:text-primary-80">
          <GraduationCap size={20} strokeWidth={2} />
        </span>
        <div className="min-w-0">
          <h2 className="text-lg font-semibold leading-tight">{t("training.programmes.title")}</h2>
          <p className="text-sm text-grey-50 dark:text-grey-70 mt-0.5">{isDrivingSchool ? t("training.settingsLink.description") : t("training.settingsLink.descriptionCourses")}</p>
        </div>
      </div>
      <Link
        to={ROUTES.PROGRAMMES_SETTINGS}
        className="flex items-center gap-1 text-primary-40 dark:text-primary-90 hover:underline font-medium"
      >
        <span>{t("training.settingsLink.open")}</span>
        <ChevronRight size={16} />
      </Link>
    </div>
  );
};

export default ProgrammesSettingsLink;
